import { useState } from "react";
import { memberApi } from "../lib/api";
import { toast } from "sonner";

const money = (n) => `${Number(n).toFixed(2).replace(".", ",")} $`;

// Programmes dédiés dans « Choisis ton abonnement » : Petits Samouraïs Parent-Enfant (3-6 ans) et PowerKick Her.
export default function MemberProgramsSection({ programs }) {
  const [formule, setFormule] = useState({});
  const [busy, setBusy] = useState(null);
  if (!programs?.length) return null;

  const choose = async (p) => {
    const f = formule[p.key] || p.formules.find((x) => x.recommended)?.key || p.formules[0].key;
    setBusy(p.key);
    try {
      const r = await memberApi.post("/member/subscription-interest", { plan_key: p.key, formule: f, discipline: p.nom });
      toast.success(r.data.message || "Demande envoyée ! Le dojo te contacte pour finaliser.");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(null); }
  };

  return (
    <div className="mt-8" data-testid="member-programs">
      <div className="kz-mono text-[11px] tracking-[0.2em] uppercase text-white/50">Programmes dédiés</div>
      <div className="grid md:grid-cols-2 gap-4 mt-3">
        {programs.map((p) => {
          const sel = formule[p.key] || p.formules.find((x) => x.recommended)?.key || p.formules[0].key;
          const f = p.formules.find((x) => x.key === sel) || p.formules[0];
          const isPkh = p.key === "powerkick_her";
          return (
            <div key={p.key} data-testid={`program-${p.key}`} className={`relative border p-6 flex flex-col ${isPkh ? "border-rose-500/60 bg-rose-500/[0.06]" : "border-[#C9A961]/50 bg-[#C9A961]/[0.05]"}`}>
              <span className={`absolute -top-3 left-5 text-[10px] kz-mono tracking-[0.18em] px-3 py-1 uppercase ${isPkh ? "bg-rose-600 text-white" : "bg-[#C9A961] text-black"}`} data-testid={`program-badge-${p.key}`}>{p.badge}</span>
              <div className="flex items-start gap-3 mt-1">
                <div className="text-3xl">{p.emoji}</div>
                <div>
                  <div className="kz-display text-2xl leading-tight">{p.nom}</div>
                  <p className="text-white/60 text-sm mt-1">{p.desc}</p>
                </div>
              </div>
              {p.formules.length > 1 && (
                <div className="flex gap-2 flex-wrap mt-4" data-testid={`program-formules-${p.key}`}>
                  {p.formules.map((x) => (
                    <button key={x.key} onClick={() => setFormule((s) => ({ ...s, [p.key]: x.key }))} data-testid={`program-formule-${p.key}-${x.key}`}
                      className={`px-3 py-1.5 text-xs border transition-colors ${sel === x.key ? "border-[#C9A961] text-white bg-[#C9A961]/15" : "border-white/10 text-white/60 hover:border-white/25"}`}>{x.label}</button>
                  ))}
                </div>
              )}
              <div className="mt-4 mb-1"><span className="kz-display text-4xl" data-testid={`program-price-${p.key}`}>{money(f.price)}</span><span className="text-white/40 text-sm"> · {f.period}</span></div>
              {p.guarantee && <p className="kz-mono text-xs text-[#C9A961] mt-1" data-testid="program-guarantee">{p.guarantee}</p>}
              {isPkh && p.spots_label && <p className={`text-sm font-semibold mt-1 ${p.spots_left ? "text-rose-300" : "text-white/50"}`} data-testid="program-spots">{p.spots_label}</p>}
              <ul className="mt-4 space-y-2 flex-1">
                {p.features.map((x, i) => <li key={i} className="text-white/70 text-sm flex items-start gap-2"><span className={`mt-0.5 ${isPkh ? "text-rose-400" : "text-[#C9A961]"}`}>✓</span>{x}</li>)}
              </ul>
              <div className="mt-6 flex flex-col sm:flex-row gap-2">
                <button onClick={() => choose(p)} disabled={busy === p.key} data-testid={`program-choose-${p.key}`}
                  className={`flex-1 py-3 text-sm kz-mono tracking-[0.15em] uppercase transition-colors disabled:opacity-50 ${isPkh ? "bg-rose-600 text-white hover:bg-rose-700" : "bg-[#C9A961] text-black hover:bg-[#b8964f]"}`}>
                  {busy === p.key ? "Envoi…" : p.cta}
                </button>
                <a href={p.link} target="_blank" rel="noreferrer" data-testid={`program-link-${p.key}`}
                  className="py-3 px-4 text-sm text-center border border-white/20 text-white hover:bg-white/5 kz-mono tracking-[0.1em] uppercase">{p.link_label}</a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
